module.exports = __webpack_public_path__ + "static/media/grin-tongue-squint.6dc58bcd.svg";